module.exports = __webpack_public_path__ + "static/media/exclamation-circle.86ec05a0.svg";